import RoleBasedLayout from "./RoleBasedLayout";
import ExpensesPage from "../ui/ExpensesPage";

export default function Expenses() {
    return (
        <RoleBasedLayout>
            <ExpensesPage />
        </RoleBasedLayout>
    );
}